module.exports = __webpack_public_path__ + "img/about-chris-kulbacki-1.4bb7dd58.jpg";